import React, { CSSProperties, ReactNode, useState } from "react";
import { TMGColorBackgrounds } from "../../colors";
import { MGMicrotext } from "../MGMicrotext";
import styles from "./MGField.module.css";

let nextFieldId = 0;

export const useFieldId = (id?: string) => {
  const [generatedId] = useState(() => `mg-ds-field-${++nextFieldId}`);
  return id || generatedId;
};

export type TMGFieldProps = {
  id?: string;
  labelText?: string;
  helperText?: string;
  error?: boolean;
  errorText?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  showLabels?: boolean;
  background?: TMGColorBackgrounds;
  className?: string;
  style?: CSSProperties;
  dataTestId?: string;
};

export const MGField = ({
  id,
  labelText,
  helperText,
  errorText,
  error,
  disabled,
  readOnly,
  required,
  showLabels = true,
  background = "light",
  className,
  style,
  dataTestId,
  children,
  filled,
}: TMGFieldProps & { children: ReactNode; filled?: boolean }) => {
  const message = error && errorText ? errorText : helperText;
  return (
    <div
      className={`${styles.root} ${className || ""}`}
      style={style}
      data-mg-field=""
      data-background={background}
      data-error={!!error}
      data-disabled={!!disabled}
      data-readonly={!!readOnly}
      data-filled={!!filled}
      data-testid={dataTestId}>
      {labelText && (
        <MGMicrotext
          tagName="label"
          htmlFor={id}
          id={`${id}-label`}
          background={background}
          microtextStyleDefinition="microcopy-100-05"
          className={showLabels ? styles.label : styles.srOnly}>
          {labelText}
          {required && <span aria-hidden="true"> *</span>}
        </MGMicrotext>
      )}
      {children}
      {message && (
        <MGMicrotext
          tagName="span"
          id={`${id}-message`}
          background={background}
          microtextStyleDefinition="microcopy-80-03"
          className={showLabels ? styles.message : styles.srOnly}
          color={error ? "text-feedback-error-100" : "text-primary-03"}
          role={error ? "alert" : undefined}>
          {message}
        </MGMicrotext>
      )}
    </div>
  );
};
